<app-cobrancas-recorrentes *ngIf="recurrence" [recurrence]="recurrence" />
